import { myPagesBaseApi } from '~/store/apis/endpoints/_baseApi/myPages.base.api';
import {
  GetClientResponseDto,
  PutClientDetailsRequestDto,
} from '~/store/apis/dtos/clients/clients.dto';
import { mapGetClient } from '~/store/apis/endpoints/myPages/clients/clients.mapper';
import { ClientBase } from '~/models/clients/clientBase';

export const clientsApi = myPagesBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getClient: build.query<ClientBase, void>({
      query: () => `/client`,
      providesTags: ['Client'],
      transformResponse: (response: GetClientResponseDto) =>
        mapGetClient(response),
    }),
    putClientInfo: build.mutation<void, PutClientDetailsRequestDto>({
      query: (args) => ({
        url: `/client`,
        method: 'PUT',
        body: args,
      }),
      invalidatesTags: ['Client'],
    }),
  }),
});

export const { useLazyGetClientQuery, usePutClientInfoMutation } = clientsApi;
